module.exports = __webpack_public_path__ + "img/regions-fg@2x.a89c3ccc.png";